import { formatCurrency } from 'common/FormatUtilities';
import { DiscountText, Line, Tag, Text, TextContainer } from './styles';

interface IPromoDiscountLine {
  promoCode?: string;
  promoText: string;
  promoApplied: number;
}

export const PromoCodeLine = ({ promoCode, promoText, promoApplied }: IPromoDiscountLine) => (
  <Line>
    <TextContainer>
      <Text data-cy={'order-promo-text'}>{promoText}</Text>
      <Tag>{promoCode}</Tag>
    </TextContainer>
    <DiscountText data-cy='order-promo-value'>{`-${formatCurrency(promoApplied)}`}</DiscountText>
  </Line>
);
